import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=2f3c2bbf&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3c2bbf",
  null
  
)

export default component.exports